import { useLandaApiLazyQuery } from 'hooks/api/graphql/landa_api';
import { useEffect } from 'react';
import { UNIT_AND_LEASE_INFO } from '../../../graphql/lease/unitAndLeaseInfo';
import { DataUnitLeaseInfo } from '../../../types/unit-rent-types';

const useUnitAndLeaseInfo = (
  ticker: string
): { data: DataUnitLeaseInfo | null; loading: boolean; error: any } => {
  const [fetchUnitAndLeaseInfo, { data, loading, error }] =
    useLandaApiLazyQuery(UNIT_AND_LEASE_INFO);

  useEffect(() => {
    if (ticker) {
      fetchUnitAndLeaseInfo({
        variables: { ticker: [ticker] },
      });
    }
  }, [ticker]);

  return { data, loading, error };
};

export default useUnitAndLeaseInfo;
